import axios from "axios";

export function fetchShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/bulk`
  };
  return axios(config);
}

export function fetchShopInfo(id, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}`
  };
  return axios(config);
}

export function fetchShopEdit(id, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}`
  };
  return axios(config);
}

export function fetchSiAccounts() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/si-accounts`
  };
  return axios(config);
}

export function fetchQrcode(id, type) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}/qrcode`
  };
  return axios(config);
}

export function fetchRichmenus() {
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/richmenus`
  };
  return axios(configBusiness);
}

export function fetchManagerInfo(siAccountId, type, bType, id) {
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/${type}/si-accounts/${siAccountId}?type=${bType}&businessId=${id}`
  };
  return axios(configBusiness);
}

export function fetchRichmenuSettings(siName) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/qc/shops/richmenu-settings?siName=${siName}`
  };
  return axios(config);
}

export function fetchGoogleAddress(address) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/apis/find-address?address=${address}`
  };
  return axios(config);
}

export function fetchShopsByName(shopName) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/apis/business/${shopName}`
  };
  return axios(config);
}

export function fetchOrderLimits(data) {
  let accountId = data.accountId;
  let type = data.type;
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/${type}/accounts/${accountId}/order-limits`
  };
  return axios(config);
}
export function fetchManagers(type, accountId) {
  var config = {
      method: "get",
      url: `${process.env.VUE_APP_APIHOST}/${type}/${type}-shops/${accountId}/managers`
  };
  return axios(config);
  }

export function getStore(accountId, si="quickclick") {
  var config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/apis/line-spot/si/${si}/accounts/${accountId}`
  };
  return axios(config);
}

export function getLabelPrinter(type, businessId) {
  var config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/${type}/accounts/${businessId}/label-printer`
  };
  return axios(config);
}

export function getAccountData(accountId) {
  var config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${accountId}/developer-tool/account`
  };
  return axios(config);
}

export function getBusinessData(accountId) {
  var config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${accountId}/developer-tool/business`
  };
  return axios(config);
}

export function getPrinterTemplateById(templateId) {
  var config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/printer-template/${templateId}`
  };
  return axios(config);
}

export function getExcelJson(file_id) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_EXCEL_TO_JSON_API}/excel-json/${file_id}`
  };
  return axios(config);
}

export function fetchPromotions(data, type) {
  let businessId = data.businessId;
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${businessId}/promotions`
  };
  return axios(config);
}

export function fetchScannersUnderShop(accountId, type) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/scanners`,
  }
  return axios(config);
}